import api from './api';

const affiliateService = {
  // Demandes d'affiliation
  getRequests: async (status = null, page = 1) => {
    const params = new URLSearchParams({ page: page.toString(), limit: '20' });
    if (status) params.append('status', status);
    const response = await api.get(`/api/admin/affiliate-requests?${params}`);
    return response.data;
  },

  getRequest: async (id) => {
    const response = await api.get(`/api/admin/affiliate-requests/${id}`);
    return response.data;
  },

  approveRequest: async (id, adminNotes = '') => {
    const response = await api.post(`/api/admin/affiliate-requests/${id}/approve`, { adminNotes });
    return response.data;
  },

  rejectRequest: async (id, adminNotes = '') => {
    const response = await api.post(`/api/admin/affiliate-requests/${id}/reject`, { adminNotes });
    return response.data;
  },

  // Affiliés
  getAffiliates: async (isActive = null, page = 1) => {
    const params = new URLSearchParams({ page: page.toString(), limit: '20' });
    if (isActive !== null) params.append('isActive', isActive.toString());
    const response = await api.get(`/api/admin/affiliates?${params}`);
    return response.data;
  },

  getAffiliate: async (id) => {
    const response = await api.get(`/api/admin/affiliates/${id}`);
    return response.data;
  },

  updateAffiliate: async (id, data) => {
    const response = await api.put(`/api/admin/affiliates/${id}`, data);
    return response.data;
  },

  toggleActive: async (id) => {
    const response = await api.patch(`/api/admin/affiliates/${id}/toggle`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/api/admin/affiliates/stats');
    return response.data;
  },

  // Campagnes
  getCampaigns: async (type = null, isActive = null, page = 1) => {
    const params = new URLSearchParams({ page: page.toString(), limit: '20' });
    if (type) params.append('type', type);
    if (isActive !== null) params.append('isActive', isActive.toString());
    const response = await api.get(`/api/admin/affiliate-campaigns?${params}`);
    return response.data;
  },

  getCampaign: async (id) => {
    const response = await api.get(`/api/admin/affiliate-campaigns/${id}`);
    return response.data;
  },

  createCampaign: async (data) => {
    const response = await api.post('/api/admin/affiliate-campaigns', data);
    return response.data;
  },

  updateCampaign: async (id, data) => {
    const response = await api.put(`/api/admin/affiliate-campaigns/${id}`, data);
    return response.data;
  },

  deleteCampaign: async (id) => {
    const response = await api.delete(`/api/admin/affiliate-campaigns/${id}`);
    return response.data;
  },

  toggleCampaignActive: async (id) => {
    const response = await api.patch(`/api/admin/affiliate-campaigns/${id}/toggle`);
    return response.data;
  },

  getCampaignProducts: async (id) => {
    const response = await api.get(`/api/admin/affiliate-campaigns/${id}/products`);
    return response.data;
  },

  addCampaignProduct: async (id, productData) => {
    const response = await api.post(`/api/admin/affiliate-campaigns/${id}/products`, productData);
    return response.data;
  },

  updateCampaignProduct: async (id, productId, productData) => {
    const response = await api.put(`/api/admin/affiliate-campaigns/${id}/products/${productId}`, productData);
    return response.data;
  },

  deleteCampaignProduct: async (id, productId) => {
    const response = await api.delete(`/api/admin/affiliate-campaigns/${id}/products/${productId}`);
    return response.data;
  },

  // Demandes de produits
  getProductRequests: async (status = null, affiliateId = null, campaignId = null, page = 1) => {
    const params = new URLSearchParams({ page: page.toString(), limit: '20' });
    if (status) params.append('status', status);
    if (affiliateId) params.append('affiliateId', affiliateId.toString());
    if (campaignId) params.append('campaignId', campaignId.toString());
    const response = await api.get(`/api/admin/affiliate-product-requests?${params}`);
    return response.data;
  },

  updateProductRequestStatus: async (id, data) => {
    const response = await api.patch(`/api/admin/affiliate-product-requests/${id}/status`, data);
    return response.data;
  },

  // Avis
  getReviews: async (affiliateId = null, productId = null, isPublished = null, page = 1) => {
    const params = new URLSearchParams({ page: page.toString(), limit: '20' });
    if (affiliateId) params.append('affiliateId', affiliateId.toString());
    if (productId) params.append('productId', productId.toString());
    if (isPublished !== null) params.append('isPublished', isPublished.toString());
    const response = await api.get(`/api/admin/affiliate-reviews?${params}`);
    return response.data;
  },

  toggleReviewPublish: async (id) => {
    const response = await api.patch(`/api/admin/affiliate-reviews/${id}/publish`);
    return response.data;
  },

  toggleReviewFeatured: async (id) => {
    const response = await api.patch(`/api/admin/affiliate-reviews/${id}/feature`);
    return response.data;
  },
};

export default affiliateService;

